// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback } from 'react'
import { ConfirmationPopup } from '../../../../components/confirmation-popup/confirmationpopup'
import {
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  ARE_YOU_SURE_DELETE_ALERT_TEXT,
  CANCEL_TEXT,
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  DELETE_ALERT_TEXT,
  DELETE_TEXT,
} from '../../../../utils/constants'
import './DeleteAllergiesPopUp.scss'

const popUpBoxStyle = {
  marginTop: 200,
  maxWidth: 717,
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const DeleteAlertPopUp = ({ setPopUpOpened, popUpTitle, popUpBodyText }) => {
  const onClosePopup = () => {
    setPopUpOpened(null)
  }
  const onDeleteAction = useCallback(() => {
    setPopUpOpened(true)
  }, [])

  return (
    // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered
    <ConfirmationPopup
      title={popUpTitle}
      primaryBtnAction={onDeleteAction}
      primaryBtnText={DELETE_TEXT}
      popUpBoxStyle={popUpBoxStyle}
      secondaryBtnAction={onClosePopup}
      secondaryBtnText={CANCEL_TEXT}
      msg={popUpBodyText}
      closeAction={onClosePopup}
    />
  )
}
